import { css } from 'emotion';
import Color from 'color';

import gray from './gray';
import colors from './colors';
import { toRem, toVW } from './functions';
import presets, { baselineGrid } from './presets';
import { options, rhythm, adjustFontSizeTo } from './typography';

const linkColor = colors.accent.green;

const rte = css`
  /* headings */
  h1:not([class]),
  h2:not([class]),
  h3:not([class]),
  h4:not([class]) {
    margin-bottom: ${rhythm(options.blockMarginBottom * 0.75)};

    &:not(:first-child) {
      padding-top: ${rhythm(0.75)};
    }
  }

  /* links */
  a[href]:not([class]) {
    position: relative;
    padding: 2px 0;
    font-weight: bolder;
    text-decoration: none;
    color: ${colors.gray.gunpowder};

    &::before,
    &::after {
      content: '';
      display: block;
      position: absolute;
      left: 0;
      right: 0;
      transition: opacity 200ms ease;
    }

    &::before {
      z-index: -1;
      top: 8%;
      bottom: 8%;
      opacity: 0;
      background-color: ${Color(linkColor)
        .hsl()
        .alpha(0.24)
        .string()};
    }

    &::after {
      bottom: 8%;
      height: 2px;
      opacity: 1;
      background-color: ${linkColor};
    }

    &:hover,
    &:active,
    &:focus {
      &::before,
      &::after {
        opacity: 1;
      }
    }
  }

  /* marked text */
  mark {
    ${adjustFontSizeTo('16px')};
    display: inline;
    padding: 0.1em 0.25em;
    border-radius: ${presets.radius.default};
    background-color: ${colors.accent.highlight};
    box-shadow: inset 0 0 0 1px
      ${Color(colors.accent.highlight)
        .hsl()
        .darken(0.1)
        .string()};
  }

  /* image wrappers */
  .remark-image-wrapper {
    display: block;
    margin-bottom: ${rhythm(options.blockMarginBottom * 0.75)};
    padding: calc(${toRem(baselineGrid)} + ${toVW(baselineGrid * 6)});
    padding-bottom: 0;
    background-color: ${gray(80, 'cool')};
    overflow: hidden;

    &.full-border {
      padding-bottom: calc(${toRem(baselineGrid)} + ${toVW(baselineGrid * 6)});
    }

    > *:first-child {
      box-shadow: 0 2px 5px ${gray(80)};
    }

    img {
      vertical-align: middle;
    }
  }

  /* media */
  video {
    display: inline-block;
    max-width: 100%;
    height: auto;
    vertical-align: middle;
  }
`;

export default {
  rte,
};



// WEBPACK FOOTER //
// ./src/utils/styles.js